import {Pipe, PipeTransform} from '@angular/core';
import {EventItem} from "@model";

@Pipe({
  name: 'eventLengths', pure: true,
  standalone: false })
export class EventLengthsPipe implements PipeTransform {
  transform(event: EventItem, listSizeBreakpoint?: number): string[] {
    if (event?.lengths?.length) {
      const sorted = [...event.lengths].sort((a: any, b: any) => (a || 0) - (b || 0));
      return listSizeBreakpoint ? sorted.slice(0, listSizeBreakpoint) : sorted;
    }
    return Array.from(new Set(
      event?.racesList?.map((race: any) => race.length)
        .sort((a: any, b: any) => (a || 0) - (b || 0))
        .map((length: any) => length?.toString())
    ));
  }
}
